import { watch } from 'vue'
import type { Disclosure } from './use-disclosure'

export function useSingleDisclosureEnforcing(...disclosures: Disclosure[]) {
  for (const disclosure of disclosures) {
    watch(
      () => disclosure.isOpen,
      isOpen => {
        if (isOpen) {
          for (const otherDisclosure of disclosures) {
            if (otherDisclosure === disclosure) continue
            otherDisclosure.close()
          }
        }
      }
    )
  }
}
